function getRendimientoState(state) {
  return {
    postingLeads: state.rendimiento.postingLeads,
    postingLeadsCharts: state.rendimiento.postingLeadsCharts,
    loadingPostingLeads: state.rendimiento.loadingPostingLeads,
    loadingCharts: state.rendimiento.loadingCharts,
    hasPostingLeads: state.rendimiento.hasPostingLeads,
    hasPostingLeadsCharts: state.rendimiento.hasPostingLeadsCharts,
    leadsError: state.rendimiento.leadsError,
    leadsChartsError: state.rendimiento.leadsChartsError
  };
}

export { getRendimientoState };
